module.exports = __webpack_public_path__ + "static/media/brinde.6be46c30.png";